/**
 * Custom event names used throughout the application
 */
export const DOCTOR_PROFILE_SWITCH_EVENT = 'doctorProfileSwitch';
